document.addEventListener('DOMContentLoaded', () => {
    let selector = 'input[name="new_tp_policy[insured_type]"]';
    let insured_types = document.querySelectorAll(selector);

    // if (insured_types.length === 0) {
    //     selector = 'input[name="cms_third_party_beneficiary[bank_nationality]"]';
    //     insured_types = document.querySelectorAll(selector);
    // }

    if (insured_types.length !== 0) {
        let insured_type_selected = null;
        let individual_group_form = document.querySelectorAll('.insured_individual_attributes_container');
        let entity_group_form = document.querySelectorAll('.insured_entity_attributes_container');
        let to_be_displayed, to_be_hidden;

        for (var i = 0, len = insured_types.length; i < len; ++i) {
            if (insured_types[i].checked) {
                insured_type_selected = insured_types[i];
                break;
            }
        }

        if (insured_type_selected !== null) {

            switch (insured_type_selected.value) {
                case 'individual':
                    individual_group_form.forEach(function (e) {
                        e.classList.remove('hidden');
                    });

                    break;

                case 'entity':
                    entity_group_form.forEach(function (e) {
                        e.classList.remove('hidden');
                    });

                    break;

                default:
                    break;
            }
        }

        $(selector).click(function () {
            switch (this.value) {
                case 'individual':
                    to_be_displayed = individual_group_form;
                    to_be_hidden = entity_group_form;
                    break;

                case 'entity':
                    to_be_displayed = entity_group_form;
                    to_be_hidden = individual_group_form;
                    break;

                default:
                    break;
            }

            to_be_displayed.forEach(function (e) {
                e.classList.remove('hidden');
            });

            to_be_hidden.forEach(function (e) {
                e.classList.add('hidden');
            });
        });
    }
});
